export class NaturesSources {
  id: number;
  description: string;
  ordreTri: string;
  typeNature: boolean;
  typeSource: boolean;
  typeMail: boolean;
  serviceIds: number[];
  definition: string;
  envoiRecommande: boolean;
  accuseReceptionAutomatique: boolean;
  afficherReferenceRecommande: boolean;
  naturePrivee: boolean;
}
